import React, { useState, useEffect, useRef } from "react";
import "./ChatWidget.css"; // Optional external CSS if needed

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  // When chatbox opens, send two messages one by one
useEffect(() => {
    if (isOpen && messages.length === 0) {
      // First message instantly
      setMessages([
        { from: "bot", text: "Hello! How can I assist you today?", time: "Now" }
      ]);
  
      // Second message after delay
      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          { from: "bot", text: "You can type Hi or Hello to begin 😊", time: "Now" }
        ]);
      }, 1500);
    }
  }, [isOpen]);
  
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMsg = {
      from: "user",
      text: input,
      time: "Just Now",
    };

    setMessages((prev) => [...prev, userMsg]);
    setInput("");
    setIsTyping(true);

    setTimeout(() => replyFromAI(userMsg.text), 1200);
  };

//   const replyFromAI = async (userText) => {
//     try {
//       const res = await fetch("http://localhost:5000/api/ask", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ question: userText }),
//       });

//       const data = await res.json();

//       setMessages((prev) => [
//         ...prev,
//         {
//           from: "bot",
//           text: data.answer || "I’m here to help!",
//           time: "Just Now",
//         },
//       ]);
//     } catch (err) {
//       setMessages((prev) => [
//         ...prev,
//         {
//           from: "bot",
//           text: "⚠️ Unable to connect to AI server",
//           time: "Just Now",
//         },
//       ]);
//     }

//     setIsTyping(false);
//   };

const replyFromAI = async (userText) => {
    setIsTyping(true);
  
    const text = userText.toLowerCase();
    let reply = "Thank you! Our team will contact you soon.";
  
    // ===== SOFTWARE COMPANY BASED AUTO REPLIES =====
  
    if (text.includes("hello") || text.includes("hi")) {
      reply = "Welcome to Sight Vision IT Solution Pvt Ltd! How can we help you today?";
    }
  
    else if (text.includes("website") || text.includes("web")) {
      reply = "We develop modern business websites, eCommerce stores, ERP portals, and custom web apps. Please share your requirement.";
    }
  
    else if (text.includes("software")) {
      reply = "We build complete customized software: Billing, Inventory, CRM, ERP, School, Hospital, POS, and more. What type of software do you need?";
    }
  
    else if (text.includes("billing") || text.includes("invoice")) {
      reply = "We provide GST Billing & Inventory Software with barcode, QR, reports, stock tracking, and multi-user login.";
    }
  
    else if (text.includes("app") || text.includes("mobile")) {
      reply = "We develop Android & iOS applications for any business. Please tell your app concept.";
    }
  
    else if (text.includes("price") || text.includes("cost") || text.includes("charge")) {
      reply = "Pricing depends on the type of website or software. Please share details and we will give you best quote.";
    }
  
    else if (text.includes("contact") || text.includes("phone") || text.includes("mobile")) {
      reply = "You can contact us at: +91 XXXXXXXXXX";
    }
  
    else if (text.includes("location") || text.includes("address")) {
      reply = "Sight Vision IT Solution Pvt Ltd is located in India. Please share your city, our team will reach out shortly.";
    }
  
    else if (text.includes("erp") || text.includes("crm")) {
      reply = "We build complete CRM & ERP solutions with dashboard, employee management, reports, stock & automation.";
    }
  
    else if (text.includes("school") || text.includes("college")) {
      reply = "We provide School Management Software including attendance, fees, exam, timetable, report cards, and GPS.";
    }
  
    else if (text.includes("hospital") || text.includes("clinic")) {
      reply = "We develop complete Hospital/Clinic Management Software including OPD, IPD, billing, lab reports, and more.";
    }
  
    // === END OF COMPANY LOGIC ===
  
    // Add reply to chat after small delay
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { from: "bot", text: reply, time: "Just Now" }
      ]);
      setIsTyping(false);
    }, 1000);
  };

  
  return (
    <>
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 w-16 h-16 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 text-white text-3xl shadow-lg flex items-center justify-center animate-bounce"
          style={{ zIndex: 999999 }}
        >
          💬
        </button>
      )}

      {isOpen && (
        // <div className="fixed bottom-4 right-4 w-[360px] max-h-[90vh] bg-[#0b0c24] rounded-3xl shadow-2xl flex flex-col overflow-hidden animate-slideUp">
        <div className="fixed bottom-6 right-6 w-[280px] h-[408px] bg-[#0b0c24] rounded-3xl shadow-2xl flex flex-col overflow-hidden animate-slideUp"
        style={{ zIndex: 999999 }}>
          {/* Header */}
          <div className="h-32 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 p-6 text-white flex flex-col justify-between">
            <div className="flex items-center justify-between">
              <div className="w-12 h-12 bg-white/30 rounded-full flex items-center justify-center text-xl font-bold">
                SV
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-white text-3xl"
              >
                ×
              </button>
            </div>
            <div>
              <h2 className="text-xl font-semibold">Sight Vision ChatBot</h2>
              {/* <p className="text-sm opacity-80">
                Intelligent assistant for Sight Vision IT Solution Pvt Ltd.
              </p> */}
            </div>
          </div>

          {/* Messages */}
          <div className="flex-1 p-4 overflow-y-auto space-y-4 bg-[#0b0c24]">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`flex transition-all duration-300 transform ${
                  msg.from === "user" ? "justify-end" : "justify-start"
                }`}
              >
                {msg.from === "bot" && (
                  <div className="w-10 h-10 rounded-full bg-gray-300 mr-2"></div>
                )}

                <div>
                  <div
                    className={`px-4 py-2 rounded-2xl text-sm max-w-[220px] whitespace-pre-wrap shadow-md animate-fadeIn ${
                      msg.from === "user"
                        ? "bg-[#5736ff] text-white rounded-br-none"
                        : "bg-[#1e1f3b] text-gray-200 rounded-bl-none"
                    }`}
                  >
                    {msg.text}
                  </div>
                  <p className="text-[10px] text-gray-400 mt-1 ml-1">{msg.time}</p>
                </div>
              </div>
            ))}

            {isTyping && (
              <div className="flex items-center space-x-2">
                <div className="w-10 h-10 rounded-full bg-gray-300"></div>
                <div className="typing-bubble">
                  <span></span><span></span><span></span>
                </div>
              </div>
            )}

            <div ref={chatEndRef}></div>
          </div>

          {/* Input */}
          <div className="p-4 bg-[#10122d] border-t border-white/10 flex items-center gap-2">
            <input
              type="text"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="flex-1 p-3 rounded-full bg-[#1a1c3e] text-white text-sm outline-none border border-white/10"
            />

            <button
              onClick={sendMessage}
              className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 flex items-center justify-center text-white text-xl hover:scale-110 transition"
            >
              ➤
            </button>
          </div>
        </div>
      )}
    </>
  );
}
